import React, { useEffect } from "react";

import { graphql } from "gatsby";

import CheckoutPage from "../../../components/pages/HeatingOil/CheckoutPage";
import useStepButtonsStore from "../../../components/pages/HeatingOil/CheckoutPage/StepButtons/store";
import Robots from "../../../components/shared/Meta/Robots";
import Page from "../../../components/shared/Page";
import HeatingOilDataProvider from "../../../providers/HeatingOilDataProvider";
import Error404Page from "../../404";

const HeizoelBestellungPage = ({ params: { checkoutStep } }) => {
    const [settedChecoutStep, setCheckoutStep] = useStepButtonsStore(
        (state) => [state.checkoutStep, state.setCheckoutStep]
    );

    useEffect(() => {
        if (checkoutStep) {
            setCheckoutStep(checkoutStep);
        }
    }, [checkoutStep, setCheckoutStep]);

    if (!checkoutStep) {
        return <Error404Page />;
    }

    return (
        <>
            <Page>
                <Robots index={false} />

                <HeatingOilDataProvider {...{ checkoutStep }}>
                    {settedChecoutStep && <CheckoutPage />}
                </HeatingOilDataProvider>
            </Page>
        </>
    );
};
export default HeizoelBestellungPage;

export const query = graphql`
    query {
        page: otherPagesYaml(slug: { eq: "heizoel" }) {
            ...Page
        }
    }
`;
